var _ellipse, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJapan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_2696",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 2696",
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.557,
    height: 45.557,
    viewBox: "0 0 45.557 45.557",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u6955\\u5186\\u5F62_88",
    "data-name": "\\u6955\\u5186\\u5F62 88",
    cx: 22.778,
    cy: 22.778,
    rx: 22.778,
    ry: 22.778,
    transform: "translate(0 0)",
    fill: "#ecebeb"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1927",
    "data-name": "\\u30D1\\u30B9 1927",
    d: "M393.882,105.726a11.133,11.133,0,1,1-6.654-14.27,11.133,11.133,0,0,1,6.654,14.27",
    transform: "translate(-360.659 -79.312)",
    fill: "#ca0218"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJapan);
export default __webpack_public_path__ + "static/media/japan.5d314229831d905fe27d449bee0ba668.svg";
export { ForwardRef as ReactComponent };